import { useInvalidateReturnRequest } from "./use-invalidate-return-request.ts";
import { useApiMutation } from "./use-api-mutation";

export default function useUpdateReturnRequestDeactivateAutoTreatLogistician() {
  const invalidateReturnRequest = useInvalidateReturnRequest();

  return useApiMutation(
    "patch",
    "/shops/{shopId}/return-requests/{returnRequestId}/deactivate-auto-treat-logistician",
    {
      onSuccess(returnRequest) {
        setTimeout(
          () =>
            invalidateReturnRequest({
              returnRequestId: returnRequest.id,
              shopId: returnRequest.shopId,
            }),
          100,
        );
      },
    },
  );
}
